module.exports = __webpack_public_path__ + "static/media/400009_01.1200c4be.png";